<template>
  <div style="padding: 20px 10px">
    <el-row>
      <el-col :span="10">
        {{ yTitle }}
      </el-col>
      <el-col :span="6">
        {{ title }}
      </el-col>
      <el-col :span="8">
      </el-col>
    </el-row>

    <div :id="chartId"
         class="chart-box">
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

// 曲线图
let lineOption = {
    tooltip: {
      trigger: "axis",
    },
    grid: {
      left: "60px",
      right: "20px",
      top: "20px",
      bottom: "30px"
    },
    calculable: true,
    xAxis: [
      {
        type: "category",
        boundaryGap: true,
        data: [],
        axisLine: {
          lineStyle: {
            color: "#606266"
          }
        },
        axisLabel: {
          // interval: 0 // 不间隔
          interval: 'auto'
        },
        axisTick: {
          show: false
        }
      }
    ],
    yAxis: [
      {
        name: "",
        type: "value",
        splitNumber: 3,
        axisLine: {
          lineStyle: {
            color: "#606266"
          }
        },
        // splitLine: {
        //   lineStyle: {
        //     type: "dashed",
        //     color: "#888"
        //   }
        // }
      }
    ],
    series: [
      {
        name: "报价",
        type: "line",
        smooth: true,
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "#0886ED" },
            { offset: 0.6, color: "#EBEEF5" }
          ])
        },
        lineStyle: {
          color: '#0886ED',
          width: 1
        },
        itemStyle: {
          color: '#0886ED',
        },
        symbol: 'circle',
        symbolSize: [6, 6],
        data: []
      }
    ]
}

export default {
  components: {
  },
  props: {
    chartId: {
      type: String,
      default: 'orderPriceTrend'
    },
    yTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    trendItem: {
      type: Array,
      default: []
    },
    waittTotal: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      highlightData: {},
      loadData: false,
      orderPriceTrend: null,
      trendJson: []
    }
  },
  watch: {},
  mounted () {
    this.orderPriceTrend = echarts.init(document.getElementById(this.chartId))

    this.trendJson = this.trendItem.map(t => {
       return t
    });
    this.trendJson.sort((a, b) => {
      return a.contractCode > b.contractCode ? 1 : -1;
    });
    this.setLineChart();

    window.onresize = () => {
      this.orderPriceTrend.resize()
    }
  },
  methods: {
    // K线图
    setLineChart () {
      if (!this.trendJson || !this.trendJson.length) {
        return
      }
      let options = _.cloneDeep(lineOption)
      options.xAxis[0].data = this.trendJson.map(item => item.contractCode)

      options.series[0].data = this.trendJson.map(item => item.todaySettle)

      options.series = options.series[0]
      this.orderPriceTrend.setOption(
        options,
        true
      );

      // 默认显示最后一条数据
      let index = options.series.data.length - 1
      this.$set(this.highlightData, 'date', options.xAxis[0].data[index])
      this.$set(this.highlightData, 'value', options.series.data[index])

      this.orderPriceTrend.on('highlight', (params) => {
        const batch = params.batch[0]
        const { dataIndex } = batch
        this.$set(this.highlightData, 'date', options.xAxis[0].data[dataIndex])
        this.$set(this.highlightData, 'value', options.series.data[dataIndex])
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.highlight_data{
  text-align: right;
  .value{
    font-size: 24px;
    color: #0886ED;
  }
  .date{
    font-size: 14px;
    color: #888;
  }
}
.chart-box{
  width: 100%; 
  height: 15rem;
}

@media screen and (max-width: 1200px) {
  .chart-box{
    height: 22rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/line-chart2.vue